document.addEventListener("DOMContentLoaded", function () {
  // Delayed start of chat customization
  setTimeout(function () {
    let attempts = 0;
    const maxAttempts = 20;

    const interval = setInterval(() => {
      const chatHost = document.querySelector("#ShopifyChat");

      if (chatHost && chatHost.shadowRoot) {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(`
          button.chat-toggle {
            width: auto;
            height: 40px;
            padding: 0 8px 0 4px;
          }
          button.chat-toggle svg {
            height: 40px !important;
          }
          button.chat-toggle strong {
            color: #fff;
            font-size: 15px;
            order: 1;
          }
          button.chat-app--close-button {
            width: 40px !important;
            height: 40px !important;
          }
          button.chat-app--close-button svg {
            height: 40px !important;
          }
          button.chat-toggle:before {
            content: "Chat with Us";
            color: #fff;
            font-size: 15px;
            font-weight: bold;
            line-height: 1;
            display: inline-block;
            order: 1;
          }
          button.chat-toggle .chat-title {
            display: none !important;
          }
        `);
        chatHost.shadowRoot.adoptedStyleSheets = [sheet];

        // Show chat after scroll
        const chatWrapper = document.querySelector("#shopify-chat");
        if (chatWrapper) {
          const onScroll = () => {
            if (window.scrollY > window.innerHeight * 0.5) {
              chatWrapper.style.display = "block";
              window.removeEventListener("scroll", onScroll);
            }
          };
          window.addEventListener("scroll", onScroll);
        }

        clearInterval(interval);
      }

      if (++attempts >= maxAttempts) clearInterval(interval);
    }, 500);
  }, 2000); // Chat delay
});